<template>
  <div class="container">
    <div class="bg" @click="toVipCenter"></div>
  </div>
</template>

<script>
import api from "./apiGo";
export default {
  /* eslint-disable */
  data() {
    return {
      wxURL: "",
      path: "/pages/storeGo/webview/webview", //小程序页面路径
      query: "url=%22https%3A%2F%2Fprod-popvip.paquapp.com%2Fh5-dooring%2Fquestionnaire%2F54%3Finitby%3Dwhale2%22", //小程序页面路径参数
      modName: "userResearch20221013_url", //当前h5页面名称 例：会员日、心意卡 用于区分不同页面存储的名称
      modTime: "userResearch20221013_url_date" // 当前h5页面名称 + '_date' 用于区分不同页面存储的时间戳
    };
  },
  watch: {},
  created() {},
  mounted() {
    console.log(localStorage.getItem(this.modName), '缓存中有地址')
    if (localStorage.getItem(this.modName)) {
      this.getStroageUrl();
    } else {
      this.getUrl(); 
    }
  },
  methods: {
    toVipCenter() {
      location.href = this.wxURL;
    },
    getStroageUrl(){
      let time1 = localStorage.getItem(this.modTime);
      let time2 = new Date().getTime();
      console.log('距第一次缓存相差了' + this.diffTimeHour(time1, time2) + '天')
      if (this.diffTimeHour(time1, time2) > 29) {
        localStorage.removeItem(this.modName);
        localStorage.removeItem(this.modTime);
        this.getUrl();
      } else {
        this.wxURL = localStorage.getItem(this.modName);
        location.href = localStorage.getItem(this.modName);
      }
    },
    getUrl(){
      let data = {
        jump_wxa: {
          path: this.path,
          query: this.query,
          env_version: 'release'
        },
        expire_type: 1,
        expire_time: 30,
        expire_interval: 2
      }
      api.getWxURLScheme(data).then(res=>{
        if (res.code === 1) {
          this.wxURL = res.data.openlink;
          localStorage.setItem(this.modName, this.wxURL);
          localStorage.setItem(this.modTime, new Date().getTime());
          location.href = this.wxURL;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    diffTimeHour(oldTime, newTime) {
      const timeDiff = newTime - oldTime;
      const formatTimeDiff = timeDiff / (3600 * 1000 * 24)
      return formatTimeDiff
    }
  }
};
</script>

<style scoped>
.bg{
  width: 750px;
  height: 1700px;
  background: url("https://res.paquapp.com/popmartvip/activity/schemeWechat/20220909.png") no-repeat;
  background-size: 100% 100%;
}
</style>
